module.exports = __webpack_public_path__ + "img/citizenship.7ccaee07.svg";